'use es6';

import http from 'conversations-http/clients/http';
export const deleteMessageInThread = ({
  threadId,
  messageId
}) => {
  const deleteUrl = `conversations-threads/v1/message/${threadId}/${messageId}?hardDelete=true`;
  return http.delete(deleteUrl);
};